module.exports = "data:image/png;base64,UklGRggBAABXRUJQVlA4WAoAAAAQAAAADgAACgAAQUxQSHEAAAABd6CokSQ1urx7X0YDl4uIAMt3lPT5TnomcJNt25U8HDtAEEYSMIOawgDHAGZgdHJ2cmZ6fwNw/a8J8C9hiYj+B6/tXQO36HQHFv++YcxZnZIPLfE/zHxshz5VinYY5myVQzw0LJLUZRwlnQAe27MGAABWUDggcAAAABADAJ0BKg8ACwACADQlAF2P4BHXfEEmAfoAfeVpVnmAAAD+/ENBGAHCnUREVfiEFjKeX/89P0/PPzXDAmw45LX5+/9M35Z/rH3x1rUdNeE0NhS3+OfblMs3GnPCG96LFM/4oiZB2gIfYx22x4M5wAA="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes/Pin_connected_VarA.png
// module id = 34
// module chunks = 0